import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BranchCodesEffects } from './branch-codes.effects';
import { STORE_TYPE } from './branch-codes.model';
import { branchCodesReducer } from './branch-codes.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, branchCodesReducer),
    EffectsModule.forFeature([BranchCodesEffects]),
  ],
})
export class UIBranchCodesStoreModule {}